import { styled } from '@mui/material';
import { useMemo } from 'react';
import { IConversationMessage } from 'src/@types/conversation';
import Iconify from 'src/components/iconify';
import Lightbox, { Slide } from 'src/components/lightbox';
import { handleDownloadChatMedia } from 'src/sections/@dashboard/chat/ChatConversation/shared/utils';
import { useMessageMediaContent } from '../state/ConversationMedia';
import { createSlideFromMessage } from './utils';

type Props = {
  message: IConversationMessage;
  onClose(): void;
};

export const ConversationMediaContentView = ({ message, onClose }: Props) => {
  const { mediaContent } = useMessageMediaContent(message);

  const onDownload = async () => {
    await handleDownloadChatMedia(
      mediaContent?.mediaContent as string,
      message.fileName,
      message.contentType,
    );
  };

  const imagesLightbox = useMemo(() => {
    if (!mediaContent?.mediaContent) return [];
    const slide = createSlideFromMessage(message, mediaContent.mediaContent);
    return slide ? [slide] : [];
  }, [message, mediaContent?.mediaContent]);

  return (
    <Lightbox
      index={0}
      slides={
        imagesLightbox.length ? imagesLightbox : [{ type: undefined } as Slide]
      }
      open
      close={onClose}
      disabledThumbnails
      disabledSlideshow
      toolbar={{
        buttons: [
          <DownloadButton key="download-button" onClick={onDownload}>
            <Iconify width={24} icon="tabler:download" />
          </DownloadButton>,
          'close',
        ],
      }}
    />
  );
};

const DownloadButton = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 1),
  cursor: 'pointer',
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.text.primary,
  },
}));
